import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhatIsChanging from './components/WhatIsChanging';
import ThreePillars from './components/ThreePillars';
import WhoWeHelp from './components/WhoWeHelp';
import FreeAudit from './components/FreeAudit';
import WhyUs from './components/WhyUs';
import FAQ from './components/FAQ';
import CTAStrip from './components/CTAStrip';

export const metadata = {
  title: 'Florida AI Marketing Experts - Home',
  description: 'Discover how Florida AI Marketing Experts can help your business thrive with our expert marketing services.',
  keywords: 'Florida AI Marketing Experts, marketing services',
  alternates: { canonical: 'https://floridaaimarketingexperts.com/' },
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <WhatIsChanging />
      <ThreePillars />
      <WhoWeHelp />
      <FreeAudit />
      <WhyUs />
      <FAQ />
      <CTAStrip />
      <Footer />
    </div>
  );
}
